import styled from 'styled-components'

import accordionMinusIcon from 'assets/images/accordion-minus-icon.svg'
import accordionPlusIcon from 'assets/images/accordion-plus-icon.svg'

import { Color } from 'root-constants'

export const StyledWellnessAccordion = {
  Item: styled.details`
    &[open] summary::after {
      background-image: url(${accordionMinusIcon});
    }
  `,
  Title: styled.summary`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: ${Color.INK_DARKEST};
    cursor: pointer;
    list-style: none;

    border-radius: 16px;
    background: ${Color.GRAY_LIGHTEST};

    padding: 16px;

    &::-webkit-details-marker {
      display: none;
    }

    &::after {
      content: '';
      flex-shrink: 0;

      width: 32px;
      height: 32px;

      border-radius: 8px;
      background: ${Color.WHITE} url(${accordionPlusIcon}) center no-repeat;
      background-size: 20px 20px;
    }
  `,
  Body: styled.div`
    padding: 0 16px;
    margin-top: 12px;
  `,
}
